export default __webpack_public_path__ + "static/media/icon-video.3e7ba46a.svg";